import { render, staticRenderFns } from "./PopupConfirm.vue?vue&type=template&id=445ddd56&scoped=true&"
import script from "./PopupConfirm.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirm.vue?vue&type=style&index=0&id=445ddd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ddd56",
  null
  
)

export default component.exports